import CrossIcon from '@components/icons/cross-icon';
import { noop } from '@crocodille/util';
import { Dialog } from '@headlessui/react';
import CircleButton from '../circle-button/circle-button';
import { useTranslation } from 'react-i18next';

import styles from './drawer-modal.module.scss';

interface DrawerModalProps {
  readonly open: boolean;
  onClose?(): void;
  readonly showCloseButton?: boolean;
  readonly title: string;
}

const DrawerModal: React.FC<React.PropsWithChildren<DrawerModalProps>> = ({
  open,
  onClose,
  showCloseButton = true,
  title,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose ?? noop}>
      <div className={styles.backdrop}></div>
      <Dialog.Panel className={styles.panel}>
        <Dialog.Title className={styles.title}>{title}</Dialog.Title>
        {showCloseButton ? (
          <CircleButton
            secondary
            label={t('modal.close')}
            className={styles.closeButton}
            onClick={onClose}
            hiddenLabel
          >
            <CrossIcon className={styles.closeIcon} />
          </CircleButton>
        ) : null}
        {children}
      </Dialog.Panel>
    </Dialog>
  );
};

export default DrawerModal;
